import { render } from "./Shorts.vue?vue&type=template&id=10818d9f&scoped=true"
import script from "./Shorts.vue?vue&type=script&lang=js"
export * from "./Shorts.vue?vue&type=script&lang=js"

import "./Shorts.vue?vue&type=style&index=0&id=10818d9f&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10818d9f"]])

export default __exports__